import { atom } from "jotai";
import { graphql, readInlineData } from "react-relay";

import { currentItemAtom } from "scmp-app/lib/current-item";
import type { atomsCurrentNotificationSectionAtomBase$key } from "scmp-app/queries/__generated__/atomsCurrentNotificationSectionAtomBase.graphql";

export const currentNotificationSectionAtom = atom(get => {
  const currentItem = get(currentItemAtom);
  if (!currentItem) return;

  const item = readInlineData<atomsCurrentNotificationSectionAtomBase$key>(
    graphql`
      fragment atomsCurrentNotificationSectionAtomBase on BaseWithApplicationAndUrlAlias @inline {
        __typename
        ... on Section {
          fullSectionPath {
            ...hooksUseNotificationsSection
          }
        }
        ... on Article {
          sections {
            value {
              ...hooksUseNotificationsSection
            }
          }
        }
      }
    `,
    currentItem,
  );

  switch (item.__typename) {
    case "%other":
      return;
    case "Article": {
      const firstSection = item.sections?.[0]?.value;
      return firstSection?.at(1) ?? firstSection?.at(0);
    }
    case "Section":
      return item.fullSectionPath?.at(1) ?? item.fullSectionPath?.at(0);
  }
});
